import { mdiEmailOutline } from "@mdi/js"
import type { AdministrationSubviewConfig } from "@kontextwerk/control-web-frame/components/administration"
import type { OrgaViewFrameContext } from "../../../../context"

export const subviewConfig: AdministrationSubviewConfig<OrgaViewFrameContext> = {
  id: "daily-briefing",
  title: "Morgenübersicht",
  icon: mdiEmailOutline,
  tooltip: "Persönlichen Tagesplan, PDF und Planungsausblick per E-Mail einstellen.",
  routeSegment: "daily-briefing",
  getPages: () => [
    {
      id: "daily-briefing",
      title: "Morgenübersicht",
      path: "",
      widthType: "normal",
      testId: "controlAdmin.organizationView.tab.dailyBriefing",
    },
  ],
}
